<ion-modal [isOpen]="isOpen" (didDismiss)="onCloseModal()" [backdropDismiss]="true" [cssClass]="'fullscreen-modal'" [backdropOpacity]="0.9">
  <ng-template>
    <ion-content class="photo-viewer-content ion-no-padding">
      <!-- Close button in top right -->
      <ion-button fill="clear" class="close-button" (click)="onCloseModal()">
        <ion-icon name="close" slot="icon-only" size="large"></ion-icon>
      </ion-button>
      
      <!-- Photo Display with Zoom -->
      <div class="photo-container" *ngIf="selectedPhoto && selectedPhoto.url">
        <div class="photo-viewer" #photoViewer>
          <div class="image-wrapper" (click)="toggleZoom($event)">
            <img
              #photoImage
              [src]="selectedPhoto.url"
              [alt]="selectedPhoto.name || selectedPhoto.blobName || 'Photo'"
              class="photo-image"
              [class.zoomed]="scale > 1"
              [style.transform]="imageTransform"
              (dblclick)="resetZoom()"
            >
          </div>
        </div>
      </div>
      
      <!-- Photo name/info -->
      <div class="photo-info" *ngIf="selectedPhoto?.name || selectedPhoto?.blobName">
        <span class="photo-name">{{ selectedPhoto?.name || selectedPhoto?.blobName }}</span>
      </div>
      
      <!-- Photo Navigation -->
      <div class="photo-navigation">
        <ion-button fill="clear" [disabled]="currentPhotoIndex === 0" (click)="navigatePhoto(-1)">
          <ion-icon name="chevron-back-outline" slot="icon-only" size="large"></ion-icon>
        </ion-button>
        <span class="photo-counter">{{(currentPhotoIndex + 1) +' of ' + photoList.length }}</span>
        <ion-button fill="clear" [disabled]="currentPhotoIndex === photoList.length - 1" (click)="navigatePhoto(1)">
          <ion-icon name="chevron-forward-outline" slot="icon-only" size="large"></ion-icon>
        </ion-button>
      </div>

      <!-- Zoom / rotate controls -->
      <div class="zoom-controls">
        <ion-button fill="clear" title="Zoom out" (click)="zoomOut()" [disabled]="scale <= minScale">
          <ion-icon name="remove-circle-outline" slot="icon-only" size="large"></ion-icon>
        </ion-button>
        <ion-button fill="clear" title="Reset view" (click)="resetZoom()">
          <ion-icon name="contract-outline" slot="icon-only" size="large"></ion-icon>
        </ion-button>
        <ion-button fill="clear" title="Rotate" (click)="rotatePhoto()">
          <ion-icon name="refresh-outline" slot="icon-only" size="large"></ion-icon>
        </ion-button>
        <ion-button fill="clear" title="Zoom in" (click)="zoomIn()" [disabled]="scale >= maxScale">
          <ion-icon name="add-circle-outline" slot="icon-only" size="large"></ion-icon>
        </ion-button>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>